import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { OfferCartsState } from './types'
import { RootState } from '../types'

export const state: OfferCartsState = {
  offers: [],
  activeOffer: null,

  addOfferItemRequired: null,
  addedOfferItem: false,
  uploadInventoryListRequired: null,

  deletingOfferItemIds: [],
  updatingOfferItemIds: [],

  requestPostOffer: false,
  requestDeleteOffer: false,
  requestPostOfferItem: false,
  requestPostOfferComplete: false,
  requestPostOfferRevise: false,
  requestUploadInventoryList: false,

  error: null,
}

const namespaced: boolean = true

export const offerCarts: Module<OfferCartsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
